module.exports = __webpack_public_path__ + "img/payment_service-128.f0c9a6dc.png";